// @flow

import { graphql } from 'react-relay';
import { ROOT_ID } from 'relay-runtime';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation AddPOApprovalRuleMutation($input: AddPOApprovalRuleInput!) {
    addPOApprovalRule(input: $input) {
      poApprovalRuleEdge {
        node {
          id
          minAmount
          maxAmount
          approver {
            id
            firstName
            lastName
            email
          }
          createdAt
        }
      }
    }
  }
`;

export default {
  commit: (options: *) => {
    return createRelayMutation(mutation, {
      ...options,
      configs: [
        {
          type: 'RANGE_ADD',
          parentID: ROOT_ID,
          connectionInfo: [
            {
              key: 'POApprovalRules_poApprovalRules',
              rangeBehavior: 'prepend',
            },
          ],
          edgeName: 'poApprovalRuleEdge',
        },
      ],
    });
  },
};
